var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAttachment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8887_2539)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.9999 7.00003L8.49995 13.5C8.10212 13.8979 7.87863 14.4374 7.87863 15C7.87863 15.5626 8.10212 16.1022 8.49995 16.5C8.89777 16.8979 9.43734 17.1213 9.99995 17.1213C10.5626 17.1213 11.1021 16.8979 11.4999 16.5L17.9999 10C18.7956 9.20438 19.2426 8.12524 19.2426 7.00003C19.2426 5.87481 18.7956 4.79568 17.9999 4.00003C17.2043 3.20438 16.1252 2.75739 14.9999 2.75739C13.8747 2.75739 12.7956 3.20438 11.9999 4.00003L5.49995 10.5C4.30647 11.6935 3.63599 13.3122 3.63599 15C3.63599 16.6879 4.30647 18.3066 5.49995 19.5C6.69342 20.6935 8.31212 21.364 9.99995 21.364C11.6878 21.364 13.3065 20.6935 14.4999 19.5L20.9999 13",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8887_2539"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttachment);
export default __webpack_public_path__ + "static/media/attachment.409ab8068e21fd47abc4e39e25f320e1.svg";
export { ForwardRef as ReactComponent };